import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import SvgQuiet from '../../components/fromSvg/SvgQuiet';
import SvgClean from '../../components/fromSvg/SvgClean';
import SvgSober from '../../components/fromSvg/SvgSober';
import DefaultContainer from '../../components/DefaultContainer';
import IconWithText from './IconWithText';


const Container = styled(DefaultContainer)<{ backgroundColor?: string }>`
  background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.colors.white};
  padding: 60px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 250px;
`;

const ResponsiveContainer = styled(Container)`
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    flex-direction: row;
    align-items: flex-start;
  }
`;

const StrengthsContainer = () => {
  const theme = useContext(ThemeContext);
  return (
    <ResponsiveContainer backgroundColor={theme.colors.orange}>
      <IconWithText captionText="Czysto" icon={<SvgClean />} />
      <IconWithText captionText="Cicho" icon={<SvgQuiet />} />
      <IconWithText captionText="Trzeźwo ; ]" icon={<SvgSober />} />
    </ResponsiveContainer>
  );
};
export default StrengthsContainer;
